/**
 * @module actions/mypage
 */
import axios from 'axios'
import {
  API_URL
} from '../constants'

/**
 * @description My page information
 * @return {Promise} Axios promise
 */
export function myPageInformation (id) {
  let url = API_URL + '/Users/MyPageInfo/' + id
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description My messages
 * @return {Promise} Axios promise
 */
export function getMyMessages (id) {
  let url = API_URL + '/Message/GetUser/' + id
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Get message
 * @return {Promise} Axios promise
 */
export function getMessage (id) {
  let url = API_URL + '/Message/Get/' + id
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description My orders
 * @return {Promise} Axios promise
 */
export function getMyOrders (id) {
  let url = API_URL + '/Order/UserOrders/' + id
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description My tasks
 * @return {Promise} Axios promise
 */
export function getMyTasks (id) {
  let url = API_URL + '/OtherTask/GetEmployeeOccurrences/' + id
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Get occurence task
 * @return {Promise} Axios promise
 */
export function getOccurenceFiles (id) {
  let url = API_URL + '/OtherTask/GetOccurrenceFiles/' + id
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Start other task
 * @return {Promise} Axios promise
 */
export function startOtherTask (data) {
  let url = API_URL + '/OtherTask/Start'
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description Stop other task
 * @return {Promise} Axios promise
 */
export function stopOtherTask (data) {
  let url = API_URL + '/OtherTask/Stop'
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description Assign current user to an occurrence
 * @return {Promise} Axios promise
 */
export function assignUser (OccurrenceId) {
  let url = API_URL + '/OtherTask/Assign/' + OccurrenceId
  return dispatch => {
    return axios.get(url)
  }
}



// WEBPACK FOOTER //
// ./src/app/actions/mypage.js